import {
    AlternativePaymentMethodIntegrationUpdateParameters,
    AlternativePaymentMethodIntegrations,
} from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';
import { PaymentMethodsState } from './AlternativePaymentMethodIntegration';

export const getUpdatedPaymentMethods = (
    paymentMethodInitialState: PaymentMethodsState,
    enabledPaymentMethods: AlternativePaymentMethodIntegrationUpdateParameters['paymentMethods']
) =>
    Object.entries(paymentMethodInitialState)
        .filter(([paymentMethod, initiallyEnabled]) => {
            // payment method initially enabled and updated to disable
            if (
                initiallyEnabled &&
                !enabledPaymentMethods.some((enabledPaymentMethod) => enabledPaymentMethod === paymentMethod)
            ) {
                return true;
            }
            // payment method initially disabled and updated to enable
            if (
                !initiallyEnabled &&
                enabledPaymentMethods.some((enabledPaymentMethod) => enabledPaymentMethod === paymentMethod)
            ) {
                return true;
            }
            return false;
        })
        .map(([method]) => method);

export const getSuccessfulSubmitTextKey = (paymentMethods: string[]) => {
    const includesIdeal = paymentMethods.includes(AlternativePaymentMethodIntegrations.Ideal);
    const includesSepa = paymentMethods.includes(AlternativePaymentMethodIntegrations.SepaDirectDebit);

    if (includesIdeal && includesSepa) {
        return TextKey.SavedChangesToSepaAndIdeal;
    }

    if (includesSepa) {
        return TextKey.SavedChangesToSepa;
    }

    if (includesIdeal) {
        return TextKey.SavedChangesToIdeal;
    }

    return TextKey.SettingsStayedSame;
};
